jQuery(function($){

  if(typeof $('.featured-programs').slick !== "undefined") {

    $('.featured-programs .featured-programs__small-slider').slick({
        infinite: true,
        slidesToShow: 6,
        arrows: false,
        focusOnSelect: true,
        asNavFor: '.featured-programs__big-slider',
        responsive: [
          {
            breakpoint: 767,
            settings: {
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 3,
                centerMode: true,
                centerPadding: '0px',
                slidesToScroll: 1,
                arrows: true,
                swipeToSlide: true,
            }
          }
        ],
    });

    $('.featured-programs .featured-programs__big-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        asNavFor: '.featured-programs__small-slider',
        responsive: [
          {
            breakpoint: 767,
            settings: {
                autoplay: false,
            }
          }
        ],
    });
  }

});